export default "__VITE_ASSET__1d4e98d8__"